import './layout.css';
import PropTypes from 'prop-types';
import React from 'react';

import LeftRightSplit from '../LeftRightSplit';

function InlineInputControlRow({
  label = undefined,
  mode = 'regular',
  alignRight=false,
  bold = false,
  red = false,
  onLabelClick = undefined,
  underline = false,
  children = undefined,
  validationFor = undefined,
  smallMargin = false,
  useLeftMargin = false,
  id = undefined,
  row = undefined,
}: {
  label?: React.ReactNode|string|undefined,
  validationFor?: string|undefined,
  underline?: boolean,
  bold?: boolean,
  red?: boolean,
  alignRight?: boolean,
  smallMargin?: boolean,
  useLeftMargin?: boolean,
  onLabelClick?: VoidFunction|undefined,
  children?: React.ReactChild|React.ReactNode|string|null|undefined,
  mode: 'w210'|'extralarge'|'extralarge2'|'large'|'regular'|'small'|'extrasmall'|'xxsmall'|'xsmall'|'medium'|'xxlarge'|'xxxlarge'|'smaller'
  |'smaller-2x'|'w170'|'w180'|'w190'|'w150'|'w200'|'w90'|'w250'|'w40'|'w65'|'w70'|'w80'|'w160'|'w50'|'w100'|'w60'|'w115'|'w116'|'w130'|'w230'|'w270'|'w95'|'none'
  id?: string|undefined,
  row?: number|undefined
}) {
  let labelStyle:React.CSSProperties = !!bold ? {fontWeight: 'bold'} : {};

  if (alignRight) {
    labelStyle ={...labelStyle, textAlign: 'right', paddingRight: '20px'};
  }

  if(useLeftMargin){
    labelStyle={...labelStyle, marginLeft:'20px'}
  }

  if (!!onLabelClick) {
    labelStyle = {...labelStyle, cursor: 'pointer'};
  } else {
    labelStyle = {...labelStyle, cursor: 'default'};
  }
  if (underline) {
    labelStyle = {...labelStyle, textDecoration: 'underline'};
  }
  if (red) {
    labelStyle = {...labelStyle, color: 'red'};
  }

  let labelSize = '130px';
  switch (mode) {
    case 'xxsmall':
      labelSize = '75px';
      break;
    case 'xsmall':
      labelSize = '100px';
      break;
    case 'small':
      labelSize = '105px';
      break;
    case 'smaller':
      labelSize = '120px';
      break;
    case 'smaller-2x':
      labelSize = '110px';
      break;
    case 'medium':
      labelSize = '140px';
      break;
    case 'large':
      labelSize = '145px';
      break;
    case 'extralarge':
      labelSize = '165px';
      break;
    case 'extralarge2':
      labelSize = '170px';
      break;
    case 'w210':
      labelSize = '210px';
      break;
    case 'extrasmall':
      labelSize = '30px';
      break;
    case 'xxlarge':
      labelSize = '220px';
      break;
      case 'xxxlarge':
      labelSize = '290px';
      break;
    case 'w150':
      labelSize = '150px';
      break;
    case 'w170':
      labelSize = '170px';
      break;
    case 'w180':
      labelSize = '180px';
      break;
      case 'w190':
      labelSize = '190px';
      break;
    case 'w200':
      labelSize = '200px';
      break;
    case 'w90':
      labelSize = '90px';
      break;
    case 'w250':
      labelSize = '250px';
      break;
    case 'w40':
      labelSize = '40px';
      break;
    case 'w65':
      labelSize = '65px';
      break;
    case 'w70':
      labelSize = '70px';
      break;
    case 'w80':
      labelSize = '80px';
      break;
    case 'w160':
      labelSize = '160px';
      break;
    case 'w50':
      labelSize = '50px';
      break;
    case 'w100':
      labelSize = '100px';
      break;
    case 'w60':
      labelSize = '60px';
      break;
    case 'w115':
      labelSize = '115px';
      break;
    case 'w116':
      labelSize = '116px';
      break;
    case 'w130':
      labelSize = '130px';
      break;
    case 'w230':
      labelSize = '230px';
      break;
    case 'w270':
      labelSize = '270px';
      break;
    case 'w95':
      labelSize = '95px';
      break;
    case 'none':
      labelSize = '0px';
      break;
    default:
      break;
  }

  // const labelSize = mode === 'small' ? '105px' : (mode === 'large' ? '145px' : '130px');

  const renderedLabel = label || <>&nbsp;</>;

  let rowClass = smallMargin ? 'ifms-input-ctr-row3-small-margin' : 'ifms-input-ctr-row3';

  if (row) {
    switch(row) {
      case 2:
        rowClass = smallMargin ? 'ifms-input-ctr-row3-2x-small-margin' : 'ifms-input-ctr-row3-2x';
        break;
      case 3:
        rowClass = smallMargin ? 'ifms-input-ctr-row3-3x-small-margin' : 'ifms-input-ctr-row3-3x';
        break;
      default:
        rowClass = smallMargin ? 'ifms-input-ctr-row3-small-margin' : 'ifms-input-ctr-row3';
        break;
    }
  }

  return (
    <div className={rowClass}>
      <LeftRightSplit
        leftSize={labelSize}
        rightSize={`calc(100% - ${labelSize})`}
        left={
          <div id={id} style={labelStyle} onClick={onLabelClick} data-validationfor={validationFor}>{renderedLabel}</div>
          }
        right={
          <>
            {children}
          </>
        }
      />
    </div>
  );
}

InlineInputControlRow.defaultProps = {
  label: '',
  mode: 'regular',
  bold: false,
  red: false,
  underline: false,
  smallMargin: false,
  useLeftMargin: false,
};

InlineInputControlRow.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  right: PropTypes.node,
  bold: PropTypes.bool.isRequired,
  red: PropTypes.bool.isRequired,
  underline: PropTypes.bool.isRequired,
  onLabelClick: PropTypes.func,
  mode: PropTypes.oneOf(['w210', 'extralarge', 'extralarge2', 'large', 'regular', 'small', 'extrasmall', 'xxsmall', 'xsmall','medium', 'xxlarge', 'xxxlarge', 'smaller',
  'smaller-2x', 'w170', 'w180', 'w190', 'w150', 'w200', 'w90','w95', 'w40', 'w250', 'w70',  'w80', 'w160', 'w50', 'w100', 'w60', 'w115', 'w116','w130', 'w230', 'w270']).isRequired,
  validationFor: PropTypes.string,
  smallMargin: PropTypes.bool.isRequired,
  useLeftMargin: PropTypes.bool.isRequired,
};

export default React.memo(InlineInputControlRow);
